import { BucketTooltip, Label } from '../components/map/map.interfaces';
import { CustomMarkerData } from '../interfaces/map.interface';

export class CustomMarker {
  public id: string;
  public latitude: number;
  public longitude: number;
  public kind: string;
  public data?: CustomMarkerData;
  public icon?: Icon;
  public label?: MarkerLabel;
  public isAggregated?: boolean;
  public radius?: number;
  public infoLabels?: Label[];
  public isOpen?: boolean;
  public locationLiteral?: string;
  public tooltips?: BucketTooltip[];
  public itemsCount?: number;
  public itemKind?: string;

  public constructor(kind: string) {
    this.kind = kind;
  }
}

export interface Point {
  x: number;
  y: number;
}

export interface Size {
  height: number;
  width: number;
}

export interface Icon {
  anchor?: Point;
  labelOrigin?: Point;
  origin?: Point;
  scaledSize?: Size;
  size?: Size;
  url: string;
}

export interface MarkerLabel {
  color: string;
  fontWeight: string;
  text: string;
  fontFamily?: string;
  fontSize?: string;
}
